
export interface DashboardState {
    getLatestCallsPending: boolean,
    latestCalls: RecentCalls[],
    getLatestCallsError: string | null
}

export interface IRecentCalls {

    CustomerId: string | null,
    PersianTime: string | null,
    FromNumber: string | null,
    ToNumber: string | null,
    Type: string | null,
    PersianConnectTime: string | null,
    PersianStartTime: string | null,
    StartTime: string | null,
    ConnectTime: string | null,
    EndTime: string | null,
    Duration: string | null,
    DurationText: string | null,
    Cost: number | null,
    DispositionText: string | null,
    TotalItems: number | null,
    FromContactId: string | null,
    ToContactId: string | null,
    DownloadURL: string | null,
    CallId: string | null,
    RecordingId: string | null,
    Id: string | null,
    Errors: string | null,
    Confirms: string | null,
    Delete: boolean | null,
    PageIndex: number | null,
    PageSize: number | null

}

export class RecentCalls {
    list: IRecentCalls[] = []

    mapper(data: any[]) {
        let tempList: IRecentCalls[] = [];
        data?.forEach(item => {
            tempList.push({
                CustomerId: item.CustomerId,
                PersianTime: item.PersianTime,
                FromNumber: item.FromNumber,
                ToNumber: item.ToNumber,
                Type: item.Type,
                PersianConnectTime: item.PersianConnectTime,
                PersianStartTime: item.PersianStartTime,
                StartTime: item.StartTime,
                ConnectTime: item.ConnectTime,
                EndTime: item.EndTime,
                Duration: item.Duration,
                DurationText: item.DurationText,
                Cost: item.Cost,
                DispositionText: item.DispositionText,
                TotalItems: item.TotalItems,
                FromContactId: item.FromContactId,
                ToContactId: item.ToContactId,
                DownloadURL: item.DownloadURL,
                CallId: item.CallId,
                RecordingId: item.RecordingId,
                Id: item.Id,
                Errors: item.Errors,
                Confirms: item.Confirms,
                Delete: item.Delete,
                PageIndex: item.PageIndex,
                PageSize: item.PageSize
            })
        })
        this.list = tempList;
    }
}